import img1 from '../images/team/img-1.jpg'
import img2 from '../images/team/img-2.jpg'
import img3 from '../images/team/img-3.jpg'




const Team = [
    {
        id: '01',
        title: 'team1.tsog',
        subtitle: 'team1.tsog_sub',
        Imga: img1,
        slug: 'Tsogoo Gunsen',
    },
    {
        id: '02',
        title: 'team1.Dong-gun',
        subtitle: 'team1.Dong-gun_sub',
        Imga: img3,
        slug: 'Song Dong-Gun',
    },
    {
        id: '03',
        title: 'team1.Altanshagai',
        subtitle: 'team1.Altanshagai_sub',
        Imga: img2,
        slug: 'Altanshagai.E',
    },

]

export default Team;